export const FileType = {
  image: 0,
  video: 1,
};

export const RepairItemType = {
  Item: 0,
  Labor: 1,
};
